import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("pc_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default adminApi;
